module.exports = __webpack_public_path__ + "static/media/bg-shape2.0cc85d90.png";